import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Axios from "axios";
import Swal from "sweetalert2";
import LoadingSpinner from "../helpers/loadingspinner";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { GetJobRoles, GetScheduledCandidatebyid, UpdateInterviewCandidateByID_Rating } from "../apiconstants/constants";
import WYSIWYGEditor from "../helpers/WYSIWYGEditor";
import { useCountry } from "../contexts/countrycodecontext.js";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const CommentInterviewCompletedCandidates = () => {
    const { register, handleSubmit, control, formState: { errors, isSubmitting }, setValue, reset } = useForm();
    let query = useQuery();
    const guid = query.get("guid");
    const navigate = useNavigate();
    let Guid="";
    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const { selectedCountry} = useCountry();
    
    const roleID = localStorage.getItem("roleID")
    
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= userguid
    }
    const [isDisabled, setIsDisabled] = useState(false);
    const [jobRoles, setJobRoles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [jobRole, setJobRole] = useState();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [rating, setRating] = useState([
        { ratingID: "0", ratingName: "0 - Not-Considerable" },
        { ratingID: "1", ratingName: "1 - Not-Considerable" },
        { ratingID: "2", ratingName: "2 - Average Candidate" },
        { ratingID: "3", ratingName: "3 - Considerable Candidate" },
        { ratingID: "4", ratingName: "4 - Preferable Candidate" },
        { ratingID: "5", ratingName: "5 - Expert Candidate" },
    ]);
const token = localStorage.getItem("jwtToken");
    const fetchJobRoles = async () => {
        const GetapiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
        const response = await Axios.get(GetapiUrl);
        setJobRoles(response.data);
    };

    const getInterviewDetails = async () => {
        setIsLoading(true);
        const GetapiUrl = `${GetScheduledCandidatebyid.APIURL}/${guid}`;
        const result = await Axios.get(GetapiUrl,{ headers: { Authorization: `Bearer ${token}` } });
        const interviewData = result.data[0];
        setValue("JobRole", interviewData.jobRole);
        setName(interviewData.name);
        setEmail(interviewData.email);
        setJobRole(interviewData.jobRole);
        setStartDate(interviewData.startDate.split('T')[0]);
        setEndDate(interviewData.endDate.split('T')[0]);
        setValue("startDate", interviewData.startDate.split('T')[0]);
        setValue("endDate", interviewData.endDate.split('T')[0]);
        setValue("rating", interviewData.rating);
        setValue("comment", interviewData.comments);
        setIsLoading(false);
    };

    const onSubmit = async (data, e) => {
        e.preventDefault();
        reset();
        setIsLoading(true);
        const params = {
            guiID: guid,
            comment: data.comment,
            rating: data.rating
        };
        const apiUrl = UpdateInterviewCandidateByID_Rating.APIURL;
        try {
            const result = await Axios.post(apiUrl, params,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setIsLoading(false);
            if (result.data === 'Updated successfully') {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Reviewed Successfully',
                    showConfirmButton: false,
                    timer: 5000
                });
                navigate("/Employer/GetInterviewCompletedCandidates");
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Add correct Details',
                    showConfirmButton: false,
                    timer: 5000
                });
            }
        } catch (error) {
            console.log("Error" + error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchJobRoles();
        getInterviewDetails();
    }, [selectedCountry]);

    return (
        <ConsultantLayout>
            <section>
                {isLoading ? <center><LoadingSpinner /></center> :
                    <div className="container-fluid mt-4 pb-5">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Link to="/Employer/GetInterviewCompletedCandidates">
                                <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
                            </Link>
                            <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>Add Review</h2>
                        </div>
                        <hr />
                        <div className="card shadow-lg mt-5 p-5" style={{ border: "none" }}>
                            <div className="row mt-2">
                                <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                                    <p className="text-para"><i className="fa fa-user icons"></i> {name}</p>
                                    <p className="text-para"><i className="fa fa-envelope icons"></i> {email}</p>
                                    <p className="text-para"><i className="fa fa-cogs icons"></i> {jobRole}</p>
                                    <p className="text-para"><i className="fa fa-calendar icons"></i> {startDate}</p>
                                    <p className="text-para"><i className="fa fa-calendar icons"></i> {endDate}</p>
                                </div>
                                </div>
                                <div className="row mt-2">
                                <form onSubmit={handleSubmit(onSubmit)} id="loginform">
                                    <div className="col-sm-12 col-lg-12 col-xl-12 col-md-12">
                                        <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Rating</Tooltip>}>
                                            <select
                                                {...register("rating", { required: "Rating Required" })}
                                                className={`form-control basic-form mt-3 ${errors.rating ? 'is-invalid' : ''}`}
                                                style={{ height: 50, borderRadius: 15 }}
                                            >
                                                <option value="">Select Rating</option>
                                                {rating.map((item, index) => (
                                                    <option key={index} value={item.ratingID}>{item.ratingName}</option>
                                                ))}
                                            </select>
                                        </OverlayTrigger>
                                        <div className="invalid-feedback"> {errors.rating?.message}</div>

                                        <label style={{ color: "#00a7ac",marginTop:10 }}>Comment</label>
                                        {/* <Controller
                                            control={control}
                                            name="comment"
                                            rules={{
                                                required: { value: true, message: "Comment Required" },
                                            }}
                                            render={({ field: { onChange, onBlur, value, ref } }) => (
                                                <div>
                                                    <WYSIWYGEditor
                                                        onChange={onChange}
                                                        onBlur={onBlur}
                                                        value={value}
                                                        ref={ref}
                                                        inputExtraProps={{
                                                            required: true,
                                                        }}
                                                    />
                                                    {errors.comment && (
                                                        <p style={{ marginTop: '0.25em', fontSize: '80%', color: '#dc3545' }}>
                                                            {errors.comment.message}
                                                        </p>
                                                    )}
                                                </div>
                                            )}
                                    /> */}

<textarea 
                          placeholder='Comment'
                          type=""
                          min="0"
                          title=''
                          row='20'
                          style={{height:250}}
                          name="Comment"
                          className={`form-control basic-form mt-3 ${errors.comment ? 'is-invalid' : ''}`}
                          {...register("comment", { required: "Comment Required" })}
                      />
                                <div className="invalid-feedback"> {errors.comment?.message}</div>
                                        <Link to="/Employer/GetInterviewCompletedCandidates">
                                            <button style={{ float: "right" }} disabled={isSubmitting || isDisabled} className="btn btn-primary mt-5 ">
                                                Cancel
                                            </button>
                                        </Link>
                                        <button
                                            id="svbutton"
                                            style={{ float: "right" }}
                                            disabled={isSubmitting || isDisabled}
                                            className="btn btn-primary pf-save mb-3 mr-3 mt-5"
                                        >
                                            {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                            Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                }
            </section>
        </ConsultantLayout>
    );
};

export default CommentInterviewCompletedCandidates;
